import { HttpAdapter } from '../../../config/http/http.adapter';
import { LoginResponse } from '../../../infraestructure/interfaces';
import { RenewMapper } from '../../../infraestructure/mappers/renew.mapper';
import { User } from '../../entities';

export const RefreshTokenUseCases = async (
  fetcher: HttpAdapter
): Promise<User> => {
  try {
    const response = await fetcher.post<LoginResponse>(
      '/users/refresh-token',
      {}
    );

    return RenewMapper.fromRenewResponseToEntity(response);
  } catch (error) {
    //TODO: colocar prod console.log(error);
    throw new Error(`Error fetching login: ${error}`);
  }
};
